import { colors } from '#base/js/variables.style'

export const styles = {
  arrow: {
    color: colors.brandDark
  },
  tooltip: {
    margin: '10px',
    padding: '10px',
    backgroundColor: colors.brandDark,
    color: 'white',
    fontSize: '13px',
    borderRadius: '8px'
  }
}
